import { MutationTree } from 'vuex';
import { State } from '@/store/modules/mq/mqCommonState/mq.store';
import { KeyLabel } from "@/store/mutations-typesCommon";
import { Service } from '@/utils/types/global';
import { initialState } from '@/store/modules/mq/mqCommonState/mq.store';


const mutations: MutationTree<State> = {
    setCurrentMQType(state: State, data: KeyLabel) {
      state.currentMQType = data;
    },
    setCurrentMQService(state: State, data: Service) {
      state.currentMQService = data;
    },
    setCurrentBroker(state: State, data: KeyLabel) {
      state.currentBroker = data;
    },
    setCurrentMQSubType(state: State, data: KeyLabel) {
      state.currentMQSubType = data;
    },
    setBrokerVersionList(state: State, data: KeyLabel[]) {
      state.brokerVersionList = data;
    },
    setQueueList(state: State, data: KeyLabel[]) {
      state.queueList = data;
    },
    setTopicList(state: State, data: KeyLabel[]) {
      state.topicList = data;
    },
    setProducerList(state: State, data: KeyLabel[]) {
      state.producerList = data;
    },
    setCurrentProducer(state: State, data: KeyLabel) {
      state.currentProducer = data;
    },
    setConsumerList(state: State, data: KeyLabel[]) {
      state.consumerList = data;
    },
    setZookeeperList(state: State, data: KeyLabel[]) {
      state.zookeeperList = data;
    },
    setBrokerList(state: State, data: KeyLabel[]) {
      state.brokerList = data;
    },
    setBrokerTopicList(state: State, data: KeyLabel[]) {
      state.brokerTopicList = data;
    },
    setActiveTab(state: State, data: String) {
      state.activeTab = data;
    },
    setDefaultValues(state: State) {
      Object.assign(state, { ...initialState });
    }
  };
  
  export default mutations;

